import script from "./CallForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CallForm.vue?vue&type=script&setup=true&lang=js"

import "./CallForm.vue?vue&type=style&index=0&id=5d2fe446&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2fe446"]])

export default __exports__